// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"eb19f53d","332":"5bdfe82e","493":"ab9b7134","850":"6d3cb0af"}[chunkId] + ".chunk.js";
};